
import { Identity } from '../base/identity';

export class HorseRoleIdentity extends Identity {

    constructor(params?: Partial<HorseRoleIdentity>) {
        super(params);
    }
}
